// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LandingPageRight {
  width: 50%;
}

.landingPageRightContainer {
  position: relative;
}
.earthContainer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  margin-top: 11vh;
  overflow: hidden;
}
.earthImg {
  width: 105%;
  animation: Earth-spin infinite 120s linear;
  z-index: 1;
  transform: translateX(-2000px);
}

@keyframes Earth-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.landingMobileContainer {
  position: absolute;
  top: 0%;
  left: 0%;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}
.landingMobileContainer2 {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 80%;
  width: 100%;
}
.ellipseContainer{
  position: absolute;
  height: 100%;
  width: 100%;
}

.ellipseSmall {
  height: 2vh;
  width: 2vw;
  position: absolute;
  top: 10%;
  left: 20%;
  z-index: 2;
}
.ellipseMedium {
  position: absolute;
  height: 12vh;
  width: 12vw;
  top: 30%;
  left: 55%;
  z-index: 2;
}
.ellipseLarge {
  position: absolute;
  height: 15vh;
  width: 15vw;
  top: 50%;
  left: 0%;
  z-index: 2;
}
.landingMobileContainer3 {
  position: absolute;
  top: 15%;
  left: 16%;
  height: 65%;
  width: 28%;
  z-index: 5;
}
.landingMobileContainer4 {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.smallMobile{
  height: 100%;
  width: 100%;
  z-index: 4;
}
.largerMobile {
  height: 80%;
  width: 50%;
  z-index: 3;
  position: absolute;
  left: 28%;
  top: 7%;
}
.amalgamateVerticalLogo {
  position: absolute;
  height: 12%;
  z-index: 5;
  top: 18%;
}
.starryMobile {
  position: absolute;
  z-index: 5;
  height: 78%;
  width: 90%;
  mix-blend-mode: lighten;
  top: 20%;
}

@media screen and (max-width: 768px){
  .LandingPageRight {
    width: 100%;
  }
  .earthContainer {
    margin-top: 8vh;
  }
  .earthImg {
    width: 100%;
    animation: Earth-spin infinite 120s linear;
    z-index: 1;
    transform: translateX(-2000px);
  }
  .landingMobileContainer {
    position: absolute;
    top: 2%;
    left: 2%;
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1;
  }
  .ellipseSmall {
    height: 1.5vh;
    width: 1.5vw;
    top: 6%;
  }
  .ellipseMedium {
    height: 8vh;
    width: 8vw;
    top: 32%;
    left: 60%;
  }
  .ellipseLarge {
    height: 9vh;
    width: 9vw;
    top: 40%;
    left: 8%;
    z-index: 2;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Donation/LandingPage/LandingPageRight.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,0CAA0C;EAC1C,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,QAAQ;EACR,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,UAAU;EACV,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,WAAW;IACX,0CAA0C;IAC1C,UAAU;IACV,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,aAAa;IACb,YAAY;IACZ,OAAO;EACT;EACA;IACE,WAAW;IACX,UAAU;IACV,QAAQ;IACR,SAAS;EACX;EACA;IACE,WAAW;IACX,UAAU;IACV,QAAQ;IACR,QAAQ;IACR,UAAU;EACZ;AACF","sourcesContent":[".LandingPageRight {\n  width: 50%;\n}\n\n.landingPageRightContainer {\n  position: relative;\n}\n.earthContainer {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  margin-top: 11vh;\n  overflow: hidden;\n}\n.earthImg {\n  width: 105%;\n  animation: Earth-spin infinite 120s linear;\n  z-index: 1;\n  transform: translateX(-2000px);\n}\n\n@keyframes Earth-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n.landingMobileContainer {\n  position: absolute;\n  top: 0%;\n  left: 0%;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1;\n}\n.landingMobileContainer2 {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 80%;\n  width: 100%;\n}\n.ellipseContainer{\n  position: absolute;\n  height: 100%;\n  width: 100%;\n}\n\n.ellipseSmall {\n  height: 2vh;\n  width: 2vw;\n  position: absolute;\n  top: 10%;\n  left: 20%;\n  z-index: 2;\n}\n.ellipseMedium {\n  position: absolute;\n  height: 12vh;\n  width: 12vw;\n  top: 30%;\n  left: 55%;\n  z-index: 2;\n}\n.ellipseLarge {\n  position: absolute;\n  height: 15vh;\n  width: 15vw;\n  top: 50%;\n  left: 0%;\n  z-index: 2;\n}\n.landingMobileContainer3 {\n  position: absolute;\n  top: 15%;\n  left: 16%;\n  height: 65%;\n  width: 28%;\n  z-index: 5;\n}\n.landingMobileContainer4 {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0%;\n  left: 0%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n.smallMobile{\n  height: 100%;\n  width: 100%;\n  z-index: 4;\n}\n.largerMobile {\n  height: 80%;\n  width: 50%;\n  z-index: 3;\n  position: absolute;\n  left: 28%;\n  top: 7%;\n}\n.amalgamateVerticalLogo {\n  position: absolute;\n  height: 12%;\n  z-index: 5;\n  top: 18%;\n}\n.starryMobile {\n  position: absolute;\n  z-index: 5;\n  height: 78%;\n  width: 90%;\n  mix-blend-mode: lighten;\n  top: 20%;\n}\n\n@media screen and (max-width: 768px){\n  .LandingPageRight {\n    width: 100%;\n  }\n  .earthContainer {\n    margin-top: 8vh;\n  }\n  .earthImg {\n    width: 100%;\n    animation: Earth-spin infinite 120s linear;\n    z-index: 1;\n    transform: translateX(-2000px);\n  }\n  .landingMobileContainer {\n    position: absolute;\n    top: 2%;\n    left: 2%;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1;\n  }\n  .ellipseSmall {\n    height: 1.5vh;\n    width: 1.5vw;\n    top: 6%;\n  }\n  .ellipseMedium {\n    height: 8vh;\n    width: 8vw;\n    top: 32%;\n    left: 60%;\n  }\n  .ellipseLarge {\n    height: 9vh;\n    width: 9vw;\n    top: 40%;\n    left: 8%;\n    z-index: 2;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
